export const MAINTENANCE_REPORTS_FETCH_ALL = 'MAINTENANCE_REPORTS_FETCH_ALL';
export const MAINTENANCE_REPORTS_FETCH_BY_DC = 'MAINTENANCE_REPORTS_FETCH_BY_DC';
